export function getHeaders(): Record<string, string> {
  return {};
}
